/*
*   路口图片组件
*   zxw
*   2024-05-22
*/

import React , { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Select, 
    Modal, Button, Dropdown, Input, Image,
    Tag,
} from 'antd';
import { DownOutlined, PlusOutlined,ExclamationCircleFilled } from '@ant-design/icons';
import { UjoinParams, AddRequestHeaders, 
    winWidth,AliyunOSSclient } from '../../incs/FunHelper.js';

import Entity from './IntersectionImageEntity.js';

const Option = Select.Option;
const { TextArea } = Input;
const MODULENAME = '路口图片';

let root = null;

/**
 * 预览图片
 * @param {*} props 
 * @returns 
 */
const PreviewImage = (props) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [path,setPath] = useState('');

    useEffect(() => {
        setPreviewOpen(true);
    }, [props])

    useEffect(() => {
        /**
         * 从阿里云下载
         * @param {*} file
         */
        const aliyunOSSDownload = (file) =>{
            var params = {
                'oss': 'GetObject'
            }
            $.ajax({
                url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        const token = data.dat;
                        try {
                            //  去掉路径‘/’
                            let result = AliyunOSSclient(token).signatureUrl(file.path, {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + file.name + '"'
                                }
                            });
                            setPreviewImage(result);
                        } catch (e) {
                            console.log(e);
                        }
                    }else{
                        message.error(data.msg, 1);
                    }
                }
            });
        }

        if(props.record.path !== path){
            aliyunOSSDownload({
                name: props.record.name,
                path: props.record.path
            });
            setPath(props.record.path);
        }
        
    }, [props,path])


 
    return (
        <>
            <div style={{borderRadius: 5,}}>
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        // afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            </div>
        </>
    );
};

/**
 * 信息提示框组件
 * @param {*} props 
 * @returns 
 */
const InfoPromptModal = (props) => {
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const handleCancel = () =>{
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
   const handleOK = () =>{
        $.ajax({
            url: `${CNF.api}intersection/images/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: props.action==='DELETE'?'DELETE':'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': props.action,
                'description': description
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1);
                }
                handleCancel();
            }
        })
    }

    return (
        <>
            <Modal
                okType='danger'
                title={<><ExclamationCircleFilled style={{ color: '#FAAD13' }} /> {MODULENAME}</>}
                closeIcon={false}
                open={open}
                onOk={()=>{handleOK()}}
                onCancel={()=>{handleCancel()}}
                okText='确认'
                cancelText='取消'
                okButtonProps={{disabled: description?false:true}}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要{props.action==='DISABLE'?'禁用':props.action==='ACTIVE'?'激活':'删除'}该{MODULENAME}：{props.record.name}</p>
                    <TextArea
                        placeholder='必填字段，需要备注说明'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e)=>{setDescription(e.target.value)}}
                        value={description}
                    />
                </div>
            </Modal>
        </>
    );
}

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) =>{this.props.setIsModalOpen(true, record);}
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 从阿里云删除
     * @param {*} file 
     * @returns 
     */
    aliyunOSSDelete = (file) => {
        var params = {
            'oss': 'DeleteObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        AliyunOSSclient(token).delete(file.path);
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
        return false
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch(action){
            case 'update':
                this.update(record);
                break;
            case 'disable':
                this.showInfoPromptModal(record,'DISABLE');
                break;
            case 'active':
                this.showInfoPromptModal(record,'ACTIVE');
                break;
            case 'delete':
                this.showInfoPromptModal(record,'DELETE');
                break
            default:
                break;
        }
    }

    /**
     * 显示提示框信息信息
     * @param {*} record 
     */
    showInfoPromptModal = (record, action) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('info-prompt-modal-id'));
        }
        root.render(
            <InfoPromptModal
                open={true}
                isRefresh={this.props.isRefresh}
                action={action}
                record={record}
            />
        );
    }

    /**
     * 显示预览图片
     * @param {*} record 
     */
    showPreviewImage = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('show-info-id'));
        }
        root.render(
        <PreviewImage
            preGroup={this.props.preGroup}
            open={true}
            record={record}
        />);
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '路口名称',dataIndex: 'intersection_name',key: 'intersection_name',},
            {title: '图片名称',key: 'name',
                render: (record) => <Button type='link' 
                style={{ padding:0, border:0,height:22 }} 
                onClick={()=>{this.showPreviewImage(record);}}>{record.name}</Button>
            },
            {title: '是否主图',key: 'is_main',
                render: (record) => <Tag color={record.is_main?'geekblue':'magenta'} style={{ width: 50,textAlign:'center' }}>{record.is_main?'是':'否'}</Tag>
            },
            // {title: '路径',dataIndex: 'path',key: 'path',},
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',width: 120,},
            {title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: 100,},
            {title: '状态', key: 'status', fixed: 'right',width: 80,
                render: function(record){
                    for(let item of CNF.status){
                        if(parseInt(record.status) === parseInt(item.value)){
                            return item.key
                        }
                    }
                }
            },
            {title: '', key: 'operation', fixed: 'right', width: 80,
                render: (record) => {
                    let items = [];
                    if(this.props.btnLists.indexOf('btn_teii_intersection_image_update')>0){
                        items.push({key: '1', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('update', record)}}>修改</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_image_update') >= 0 
                    && record.status.toString() === CNF.status[0].value.toString()){
                        items.push({key: '2', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('disable', record)}}>禁用</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_image_update') >= 0 
                    && record.status.toString() === CNF.status[1].value.toString()){
                        items.push({key: '3', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('active', record)}}>激活</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_image_delete')>=0){
                        items.push({key: '4', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('delete', record)}}>删除</Button>)})
                    }
                    return (
                        <Dropdown menu={{ items, }}>
                            <Button type='link' style={{ padding:0, height: 10,margin:0 }}>
                                    操作
                                    <DownOutlined />
                            </Button>
                        </Dropdown>
                    );
                }
            }
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    // scroll={{ x: winWidth}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            intersectionUlid: '',
            name: '',
            isMain: '',
            status: 1,
            intersectionDDList: []
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeIntersectionUlid = (value, option) =>{this.setState({ intersectionUlid: value});this.search();}
    changeName = (e) =>{this.setState({name: e.target.value});this.search();}
    changeIsMain = (value) =>{ this.setState({ isMain: value});this.search();}
    changeStatus = (value) =>{ this.setState({ status: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}

    setIsModalOpen = (value, record) =>{this.setState({isModalOpen: value, record: record});}
    create = () =>{this.setIsModalOpen(true, null);}

    /***
     * 获取路口下拉列表
     */
    intersectionDDList(){
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',success:function(data){
                if(data.res === 0){
                    _this.setState({ intersectionDDList: data.dat});
                }else{
                    message.error(data.msg);
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists(){
        const _this = this;
        const params = {
            'intersection_ulid': this.state.intersectionUlid,
            'name': this.state.name,
            'is_main': this.state.isMain,
            'status': this.state.status,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}intersection/images${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.intersectionDDList();
        this.getLists();
    }

    render(){
        return(
            <>
                <div>
                    <Row style={{ height: 60, paddingTop:10, paddingLeft:20}}>
                        <Col span={4} style={{ marginLeft: 5 }}>
                            <Select 
                                showSearch
                                value={this.state.intersectionUlid}
                                style={{ width: '100%' }} 
                                onChange={this.changeIntersectionUlid}
                                disabled={this.state.loading}
                                filterOption={(input, option) =>
                                    option.props.children.indexOf(input) >= 0
                                }
                            >
                                <Option value=''>请选择路口</Option>
                                {
                                    this.state.intersectionDDList.length && this.state.intersectionDDList.map((item) => {
                                        return <Option key={item['key']} value={item['key']}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changenName}
                                onPressEnter={this.search}
                                placeholder='名称...'
                                value={this.state.name}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Select 
                                value={this.state.isMain}
                                style={{ width: '100%' }} 
                                onChange={this.changeIsMain}
                            >
                                <Option value=''>是否主图</Option>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Select 
                                value={this.state.status}
                                style={{ width: '100%' }} 
                                onChange={this.changeStatus}
                            >
                                <Option value=''>状态</Option>
                                {
                                    CNF.status && CNF.status.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ lineHeight: 2.2,marginLeft: 10 }}>
                        {
                            this.props.btnLists.indexOf('btn_teii_intersection_image_create') >=0 ? (
                                <>
                                    <Button 
                                        title={MODULENAME}
                                        type='link'
                                        icon={<PlusOutlined/>}
                                        onClick={() =>{
                                            this.create();
                                        }}>
                                    </Button>
                                </>):''
                        }
                        </Col>
                        <Entity 
                            policy={this.props.policy}
                            preGroup={this.props.preGroup}
                            isModalOpen={this.state.isModalOpen} 
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen} 
                            isRefresh={this.isRefresh}
                            intersectionDDList={this.state.intersectionDDList}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists 
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists} 
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount} 
                                changeIndex={this.changeIndex} 
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
                <div id='show-info-id'></div>
                <div id='info-prompt-modal-id'></div>
            </>
        );
    }
}

export default CPT